export default __webpack_public_path__ + "static/media/oncord.4b04bd98.png";